var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { motion } from "framer-motion";
import { getStripComponentFromStripData } from '../services/stripsService';
export default function StripTwoColumnContent(props) {
    var fields = props.fields, children = props.children, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    var getSecondColumnWidth = function (columnWidth) {
        if (columnWidth == "33") {
            return "66";
        }
        else if (columnWidth == "66") {
            return "33";
        }
        return "50";
    };
    var firstColWidth = fields.firstColumnWidth ? Number(fields.firstColumnWidth) : 12;
    var secondColOffset = (fields.rightColumnOffset ? Number(fields.rightColumnOffset) : 0);
    var secondColWidth = 12 - firstColWidth - secondColOffset;
    if (secondColWidth <= 0)
        secondColWidth = 12;
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-two-column-content position-relative text-olive component mb-4 "
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + (isFlyoverSite ? (" bg-" + (fields.backgroundColour ? fields.backgroundColour : "")) : "")
            + (isFlyoverSite ? (" text-color-" + (fields.textColour ? fields.textColour : "")) : "")
            + (isFlyoverSite ? "" : " container-fluid") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: isFlyoverSite ? "container-fluid" : "" },
            React.createElement("div", { className: "row mobile-alignment-" + (fields.mobileAlignment ? fields.mobileAlignment : "") },
                (fields.displayTitle || fields.content) &&
                    React.createElement("div", { className: "col-12 intro-text-row", itemScope: true, itemType: "https://schema.org/Thing" },
                        fields.displayTitle &&
                            React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                        fields.content &&
                            React.createElement("div", { className: "strip-content", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" })),
                React.createElement("div", { className: "col-12" + (isFlyoverSite ? " px-lg-4" : "") },
                    React.createElement("div", { className: "row justify-content-between flex-lg-nowrap" },
                        React.createElement("div", { className: "first-col col-lg-" + (firstColWidth) }, children && children[0] &&
                            React.createElement("div", { className: "row" }, getStripComponentFromStripData(children[0], { labels: props.labels, isFlyoverSite: isFlyoverSite }))),
                        React.createElement("div", { className: "second-col col-lg-".concat(secondColWidth, " offset-lg-").concat(secondColOffset) }, children && children[1] &&
                            React.createElement("div", { className: "row" }, getStripComponentFromStripData(children[1], { labels: props.labels, isFlyoverSite: isFlyoverSite })))))))));
}
